import WithRender from "../../templates/base/mainContent.html";

import { mapGetters } from "vuex";

export default WithRender({
  computed: {
    ...mapGetters(["getProductPartsNames", "getShowUpload"])
  }
});
